import type { UIComponent } from '@gik/core/types/UI';
import type React from 'react';
import { useNProgress } from './useNProgress';

export type NProgressWrapperProps = {} & UIComponent;

export function NProgressWrapper({
  children,
  className,
  ...otherProps
}: React.PropsWithChildren<NProgressWrapperProps>): React.ReactElement {
  useNProgress();

  return null;
}
